<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div>
		<h2 class="ma-2 ml-4">Oferty w komisjach</h2>

		<v-btn color="success"
			@click="autoAssignOffers">
			<v-icon class="mr-2 white--text">star</v-icon>
			Automatycznie przydziel nieprzypisane oferty
		</v-btn>

		<v-layout row wrap>
			<template v-for="(committee, index) in committees">
				<v-flex xs6
					:key="committee.id">
					<offers-list
						:offers="committee.offers"
						:contest-id="contestData.id"
						expandableAreaLabel="Lista ocen"
						:placing-offer-allowed="false"
						:bidder-name-visible="true"
						:editing-visible="false"
						:is-paginated="true"
						:color="committee.emptyCommittee ? 'blue' : 'blue' + index"
						:header="committee.emptyCommittee ? 'Oferty nieprzypisane' : committee.name"
						empty-warning="Brak ofert">
						<template v-slot:extraAction="slotData">
							<v-list-tile-action>
								<egranty-icon-button icon="swap_vert" color="primary"
									label="Przypisz ofertę do komisji"
									for="contest-manage-committess-view-assign-offer"
									id="contest-manage-committess-view-assign-offer"
									@click="openCommitteeAssignDialog(slotData.offer.id)"></egranty-icon-button>
							</v-list-tile-action>
						</template>
					</offers-list>
				</v-flex>
			</template>
		</v-layout>

		<egranty-input-field-popup
			:is-open.sync="dialogsState.committeeAssignDialogOpen"
			:select-items="committeesWithoutEmpty"
			label="Komisja dla oferty"
			for="contest-manage-committess-view-committee-for-offer"
			id="contest-manage-committess-view-committee-for-offer"
			title="Przypisz ofertę do komisji"
			field-type="SELECT"
			@save="assignSelectedOffer">
		</egranty-input-field-popup>
	</div>
</template>

<script>
	import {Committee} from "../../../api/generated/Committee";
	import OffersList from "../offer/components/OffersList";
	import EgrantyIconButton from "../../../genericComponents/EgrantyIconButton";
	import EgrantyInputFieldPopup from "../../../genericComponents/EgrantyInputFieldPopup";
	import {Offer} from "../../../api/generated/Offer";

	export default {
		name: "ContestManageCommitteesView",

		components: {OffersList, EgrantyIconButton, EgrantyInputFieldPopup},

		data() {
			return {
				contestData: {
					id: this.$route.params.id,
				},
				committees: null,
				committeesWithoutEmpty: null,
				dialogsState: {
					committeeAssignDialogOpen: false,
					selectedOfferId: null,
				},
				offersLoaded: false,
				correctionCausesLoaded: false,
				causesMatched: false,
				correctionCauses: []
			};
		},

		created() {
			this.reload();
		},

		methods: {
			reload() {
				loadCommitteesWithOffers(this);
				loadCorrectionCauses(this);
			},

			openCommitteeAssignDialog(offerId) {
				this.dialogsState.committeeAssignDialogOpen = true;
				this.dialogsState.selectedOfferId = offerId;
			},

			assignSelectedOffer(committeeId) {
				this.dialogsState.committeeAssignDialogOpen = false;

				const offerId = this.dialogsState.selectedOfferId;
				const oldCommittee = this.committees.find(c => c.offers.some(o => o.id === offerId));

				if (oldCommittee.id === committeeId) {
					this.$messagesBus.$emit("success", "Przydział oferty pozostaje bez zmian");
					return;
				}

				Committee.putAssignOffer(this, this.dialogsState.selectedOfferId, committeeId,
					successResponse => {
						const allOffers = this.committees.map(c => c.offers).flat();
						const thisOffer = allOffers.find(o => o.id === offerId);
						this.committees
							.filter(c => c.id === committeeId)
							.map(c => c.offers.push(thisOffer));

						oldCommittee.offers = oldCommittee.offers.filter(o => o.id !== offerId);

						this.$messagesBus.$emit("success", "Pomyślnie przypisano ofertę do komisji", successResponse);
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się przypisać oferty do komisji", errorResponse);
					});
			},

			autoAssignOffers() {
				Committee.postAutoAssignOffers(this, this.contestData.id,
					successResponse => {
						this.reload();
						this.$messagesBus.$emit("success", "Pomyślnie przypisano " + successResponse + " ofert do komisji", successResponse);
					},
					errorResponse => {
						this.$messagesBus.$emit("error", errorResponse.message, errorResponse);
					});
			},

			matchCauses () {
				let offersAwaitingCorrection = [];
				this.committees.forEach(committee => {
					committee.offers.forEach(offer => {
						if (offer.offerStatus === 'AWAITING_CORRECTION') {
							offersAwaitingCorrection.push(offer);
						}
					});
				});
				offersAwaitingCorrection.forEach(offer => {
					let cause = this.correctionCauses.find(c => c.id === offer.id);
					this.$set(offer, "correctionCause", cause.correctionCause);
				});
				this.causesMatched = true;
			}
		},
	};

	function loadCommitteesWithOffers(ctx) {
		Committee.getContestCommitteesWithOffers(ctx, ctx.contestData.id,
			successResponse => {
				ctx.committees = successResponse;
				ctx.committeesWithoutEmpty = successResponse.filter(c => !c.emptyCommittee);
				ctx.offersLoaded = true;
				if (ctx.correctionCausesLoaded && !ctx.causesMatched) ctx.matchCauses();
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować komisji", errorResponse);
			});
	}

	function loadCorrectionCauses (ctx) {
		Offer.getSubmittedOffersCorrectionCauses(ctx, ctx.contestData.id,
			successResponse => {
				ctx.correctionCauses = successResponse;
				ctx.correctionCausesLoaded = true;
				if (ctx.offersLoaded && !ctx.causesMatched) ctx.matchCauses();
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować powodów do poprawek", errorResponse);
			});
	}
</script>

<style scoped>
	.theme--dark.v-btn:not(.v-btn--icon):not(.v-btn--flat) {
		background-color: #0075e2 !important;
	}
</style>
